module.exports = require("@wildboar/ldap/src/lib/destringifiers/RDNSequence");